// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-Table-control-TableComparisonRow-module__table";
export { _1 as "table" }
